import { render } from "./Menu.vue?vue&type=template&id=5685e171"
const script = {}
script.render = render

export default script